import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useMember = () => {
  const authCtx = useContext(AuthContext);
  const { sendRequest } = useHttp();

  const requestCardPrint = async (memberId, branchId) => {
    try {
      return await sendRequest({
        url: `/api/v1/members/${memberId}/requestCardPrint`,
        method: 'POST',
        body: { branchId },
        headers: authCtx.getAuthHeaders(),
      });
    } catch (err) {
      throw err;
    }
  };

  // Create a new member from a manually entered membership card number.
  const createMember = async payload => {
    try {
      return await sendRequest({
        url: `/api/v1/members`,
        method: 'POST',
        body: payload,
        headers: authCtx.getAuthHeaders(),
      });
    } catch (err) {
      throw err;
    }
  };

  // Resolve which own branch a center code maps to (own center vs foreign center).
  const resolveCenter = async centerCode => {
    try {
      return await sendRequest({
        url: `/api/v1/members/resolveCenter/${centerCode}`,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
    } catch (err) {
      throw err;
    }
  };

  return { requestCardPrint, createMember, resolveCenter };
};

export default useMember;
